import React from 'react';
import DynamicAlert from './DynamicAlert';
import { useLanguage } from '../../contexts/LanguageContext';

const WarningAlert = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  itemName,
  itemDescription,
  warningText,
  loading = false,
  confirmText,
  cancelText,
  input = null,
  inputLabel = "",
  inputPlaceholder = ""
}) => {
  const { t } = useLanguage();
  return (
    <DynamicAlert
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title={title || t('warningTitle') || "تحذير"}
      message={message || t('warningText') || "هل أنت متأكد من الاستمرار؟"}
      itemName={itemName}
      itemDescription={itemDescription}
      warningText={warningText || t('warningAttention') || "يرجى الانتباه قبل المتابعة"}
      loading={loading}
      confirmText={confirmText || t('continueBtn') || "متابعة"}
      cancelText={cancelText || t('cancel') || "إلغاء"}
      confirmColor="#6366f1"
      warningColor="#d97706"
      input={input}
      inputLabel={inputLabel}
      inputPlaceholder={inputPlaceholder}
    />
  );
};

export default WarningAlert;
